import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getApiBaseUrl } from '../services/apiClient';
import './AnketPublicPage.css';

export default function AnketPublicPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [cevaplar, setCevaplar] = useState({});
  const [istek, setIstek] = useState('');
  const [loading, setLoading] = useState(true);
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bitti, setBitti] = useState(false);

  useEffect(() => {
    document.title = 'ÜNMAK | Anket';
    return () => { document.title = 'SM Yönetim Sistemi'; };
  }, []);

  useEffect(() => {
    let iptal = false;
    const yukle = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}/api/public/anket/${encodeURIComponent(token)}`);
        const json = await res.json();
        if (iptal) return;
        if (!res.ok || !json.basarili) {
          setHata(json.mesaj || 'Anket açılamadı');
          return;
        }
        setData(json.veri);
      } catch {
        if (!iptal) setHata('Anket açılamadı');
      } finally {
        if (!iptal) setLoading(false);
      }
    };
    yukle();
    return () => { iptal = true; };
  }, [token]);

  const sorular = data?.sorular || [];
  const dolu = sorular.filter((s) => cevaplar[s.sira]).length;

  const gonder = async () => {
    setGonderiliyor(true);
    setHata('');
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/public/anket/${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cevaplar: sorular.map((s) => ({ sira: s.sira, cevap: cevaplar[s.sira] })),
          istekSikayet: istek,
        }),
      });
      const json = await res.json();
      if (!res.ok || !json.basarili) {
        setHata(json.mesaj || 'Gönderilemedi');
        return;
      }
      setBitti(true);
    } catch {
      setHata('Gönderilemedi');
    } finally {
      setGonderiliyor(false);
    }
  };

  if (loading) return <div className="anket-public"><p>Yükleniyor</p></div>;
  if (bitti) return <div className="anket-public"><div className="anket-public-kart"><h1>Anketiniz alındı</h1></div></div>;
  if (!data) return <div className="anket-public"><div className="anket-public-kart"><h1>{hata || 'Anket açılamadı'}</h1></div></div>;

  return (
    <div className="anket-public">
      <form
        className="anket-public-kart"
        onSubmit={(e) => {
          e.preventDefault();
          if (dolu === sorular.length) gonder();
        }}
      >
        <h1>{data.baslik}</h1>
        <p className="anket-public-ilerleme">{dolu}/{sorular.length}</p>
        {sorular.map((soru) => (
          <fieldset key={soru.sira} className="anket-soru">
            <legend>{soru.sira}. {soru.metin}</legend>
            <div className="anket-secenekler">
              <button
                type="button"
                className={cevaplar[soru.sira] === 'evet' ? 'secili' : ''}
                onClick={() => setCevaplar((prev) => ({ ...prev, [soru.sira]: 'evet' }))}
              >
                Evet
              </button>
              <button
                type="button"
                className={cevaplar[soru.sira] === 'hayir' ? 'secili' : ''}
                onClick={() => setCevaplar((prev) => ({ ...prev, [soru.sira]: 'hayir' }))}
              >
                Hayır
              </button>
            </div>
          </fieldset>
        ))}
        <label className="anket-istek">
          İstek ve şikayet
          <textarea
            value={istek}
            maxLength={1000}
            rows={4}
            onChange={(e) => setIstek(e.target.value)}
          />
        </label>
        {hata ? <p className="anket-hata">{hata}</p> : null}
        <button type="submit" disabled={gonderiliyor || dolu !== sorular.length}>
          {gonderiliyor ? 'Gönderiliyor' : 'Gönder'}
        </button>
      </form>
    </div>
  );
}
